import { FC } from 'react'
import styled, { useTheme } from 'styled-components'
import { LinkButton } from '@/components/common/buttons'
import FlatIcon from '@/components/common/icons/FlatIcon'
import { CartItemCountCircle } from '@/components/domains/etc'
import { ENV_CONFIG } from '@/constants/env/config'
import { FitpetMallEventEnum } from '@/constants/fitpet-mall-event.enum'
import { IconNameEnum } from '@/constants/icon-name.enum'
import { Z_INDEXES } from '@/constants/legacy/constLayout'
import ROUTES from '@/constants/legacy/constRoutes'
import { useTracker } from '@/containers/contexts/EventTrackingProvider'
import { useCustomRouter } from '@/containers/hooks'
import useShareLink from '@/containers/hooks/share-link.hook'
import { Bridge } from '@/utils/bridge/bridge'
import appBridgeProvider, { isInAppFlag } from '@/utils/utilBridge'
import { textEllipsis } from '@/utils/utilCSS'

// TODO: 이벤트 페이지용으로 기존 TopNavigation을 복사한것으로 TopNavigation 컴포넌트 작성시에 다시 합쳐야함
interface TopNavigationForEventDetailProps {
  title: string
}

const TopNavigationForEventDetail: FC<TopNavigationForEventDetailProps> = ({ title }) => {
  const { iconSize } = useTheme()
  const { triggerCustomEvent } = useTracker()
  const { query } = useCustomRouter()
  const queryPagePetType = query.pagePetType ? `?pagePetType=${query.pagePetType}` : ''
  const { processShareLink } = useShareLink()
  const handleShareLink = () => {
    const url = `${ENV_CONFIG.fitpetmallHost}/events/${query.adSlug}${queryPagePetType}`
    processShareLink(url, {
      appBridgeData: {
        title,
        eventName: FitpetMallEventEnum.ClickEventsaleSharetypeButton,
      },
    })
  }

  return (
    <StyledContainer>
      <StyledHeaderContent>
        <LinkButton goBack>
          <FlatIcon type={IconNameEnum.IcBack} size={iconSize.size24} />
        </LinkButton>
        <StyledHeaderTitle>{title}</StyledHeaderTitle>
        <LinkButton
          url={isInAppFlag ? undefined : ROUTES.INDEX}
          onClick={() => {
            triggerCustomEvent(FitpetMallEventEnum.ClickGnbHomeIcon)
            if (isInAppFlag) appBridgeProvider((bridge: Bridge) => bridge.goDeepLink('fitpetmall', '/main'))
          }}
        >
          <FlatIcon type={IconNameEnum.IcHome} size={iconSize.size24} />
        </LinkButton>
        <LinkButton onClick={() => handleShareLink()}>
          <FlatIcon type={IconNameEnum.IcShare} size={iconSize.size24} />
        </LinkButton>
        <LinkButton
          rel="nosublink"
          url={ROUTES.CART}
          onClick={() => {
            triggerCustomEvent(FitpetMallEventEnum.ClickGnbCartIcon)
          }}
          style={{ position: 'relative' }}
        >
          <CartItemCountCircle />
          <FlatIcon type={IconNameEnum.IcCart} size={iconSize.size24} />
        </LinkButton>
      </StyledHeaderContent>
    </StyledContainer>
  )
}

const StyledContainer = styled.header`
  z-index: ${Z_INDEXES.HEADER};
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  box-sizing: border-box;
  width: 100%;
  max-width: 576px;
  background-color: ${({ theme: { color } }) => color.grayWhite};
  transition: transform 0.2s;
  -webkit-transition: transform 0.2s;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 0.1rem;
    background-color: ${(props) => props.theme.color.gray50};
  }
`

const StyledHeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.6rem;
  column-gap: 1.6rem;
`

const StyledHeaderTitle = styled.div`
  ${textEllipsis(1)};
  flex-grow: 1;
  font-weight: ${(props) => props.theme.fontWeight.bold};
  font-size: ${(props) => props.theme.fontSize.h6};
  line-height: 2.4rem;
  letter-spacing: ${({ theme }) => theme.letterSpacing.font};
  color: ${(props) => props.theme.color.gray900};
`

export default TopNavigationForEventDetail
